module.exports = __webpack_public_path__ + "assets/events_coup_black.2f98ad3c.svg";